import LendersList from "./LendersList";

export default LendersList;
